const text = (value) => String(value == null ? "" : value).normalize("NFC").trim().replace(/\s+/g, " ");
const props = (event) => (event && event.extendedProps) || {};
const patientFields = ["firstname", "lastname", "hn", "node", "customer", "phone", "incomingPatientId"];

export const getBookingPatientComparison = (editing, latest) => {
  const before = props(editing);
  const after = props(latest);
  const name = (value) => [text(value.firstname), text(value.lastname)].filter(Boolean).join(" ");
  const rows = [
    ["Patient name", name(before), name(after)],
    ["HN", text(before.hn), text(after.hn)],
    ["Node", text(before.node), text(after.node)],
    ["Customer", text(before.customer), text(after.customer)],
  ];
  if (text(before.phone) !== text(after.phone)) rows.push(["Phone", text(before.phone), text(after.phone)]);
  return {
    rows: rows.map(([label, editingValue, savedValue]) => ({
      label, editingValue: editingValue || "—", savedValue: savedValue || "—", changed: editingValue !== savedValue,
    })),
    order: text(after.order || before.order || (editing && editing.title)) || "—",
    updatedBy: text(after.updatedBy || after.createBy) || "Unknown",
    missing: !latest,
  };
};

// Compare the snapshot originally loaded, not the operator's edited values.
// Run this inside the write transaction so an Incoming assignment that races
// with Save is also checked on Firestore's transaction retry.
export const assertScheduledBookingPatientUnchanged = (original, latest, editing = original) => {
  if (![original, latest, editing].some((event) => props(event).status === "Sleep Test Scheduled")) return;
  if (latest && patientFields.every((key) => text(props(original)[key]) === text(props(latest)[key]))) return;
  const error = new Error("This booking's patient information changed after it was loaded. Reload the latest booking before saving.");
  error.code = "booking-patient-changed";
  error.comparison = getBookingPatientComparison(editing, latest);
  throw error;
};
